define('lq/runtimeClone',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var prepare = function (parent) {
        _.forEach(parent.pool, function (drop) {
            if (drop.data.id) {
                if (!drop.$element.hasClass('runtime-selectable'))
                    drop.$element.addClass('runtime-selectable runtime-drop-' + drop.data.id);
            }

            prepare(drop);
        });
    };

    var RuntimeClone = function (options) {
        this.options = options;
        this.onClicked = this.select.bind(this);
        this.$container = null;
    };

    RuntimeClone.prototype.create = function () {
        prepare(this.options.action);

        var $masterPageClone = this.options.action.$masterPage
            .clone()
            .addClass('runtime-clone');
        var $actionClone = this.options.action.$element
            .clone()
            .addClass('runtime-clone');
        var $topBar = $('<div />')
            .css({
                position: 'fixed',
                top: 0,
                padding: '0.5rem 2rem',
                zIndex: 999999999,
                backgroundColor: '#4ECCFF',
                color: 'white',
                margin: '0 auto',
                left: 0,
                right: 0,
                width: '300px',
                textAlign: 'center',
                borderRadius: '0 0 0.5rem 0.5rem'
            })
            .append($('<span />').text('Select an element or '))
            .append($('<span />').text('[ cancel ]').addClass('clickable').on('click', this.cancel.bind(this)));
        this.$container = $('<div />')
            .append($masterPageClone)
            .append($actionClone)
            .append($topBar)
            .css({
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 999999999,
                backgroundColor: 'white',
                overflowY: 'auto'
            })
            .appendTo($('body'));

        $('body')
            .addClass('runtime-clone-body');

        $(document).on('click', this.onClicked);
    };

    RuntimeClone.prototype.cancel = function () {
        this.options.onCancel();
    };

    RuntimeClone.prototype.select = function (e) {
        var $closest = $(e.target).closest('.runtime-selectable');
        if ($closest.length === 0)
            return;

        var classes = $closest.attr('class').split(' ');
        var idClassName = _.find(classes, function (className) {
            return className.indexOf('runtime-drop-') === 0;
        });
        var morphId = idClassName.substring('runtime-drop-'.length);

        var $pool = $(e.target).closest('.licquid-drops-pool');
        var actionData = this.options.action.data;
        var rootMorphId = $pool.length > 0
            ? actionData.id
            : actionData.masterPageId;

        this.options.onSelect(rootMorphId, morphId);
    };
    
    RuntimeClone.prototype.destroy = function () {
        this.$container.remove();
        this.$container = null;

        $('body').removeClass('runtime-clone-body');
        $(document).off('click', this.onClicked);
    };

    return RuntimeClone;
});
